import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { EngineType, Documentations } from '../../models/enums.model';
import { FibberglassRequestDTO } from '../../models/fibberglass-request-dto.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FibberglassRequestService } from '../../services/fibberglass-request.service';
import { FibberglassConstants } from '../../models/fibberglass-constants.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { BaseRequestService } from '../../services/base-request.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-fibberglass-request',
  templateUrl: './fibberglass-request.component.html',
  styleUrls: ['./fibberglass-request.component.css']
})
export class FibberglassRequestComponent implements OnInit {

  fibberglassRequestForm: FormGroup;
  Services: LookUp[];
  BoatTypes: LookUp[];
  Clients: LookUp[];
  CommunicationsAndNavigationsOptions: LookUp[];
  LightingAndLoadsOptions: LookUp[];
  VoltDCs380On220Options: LookUp[];
  YachtSafetiesOptions: LookUp[];
  ExtraDocumentationsOptions: LookUp[];
  fibberglassRequestDTO: FibberglassRequestDTO;
  responseObj: ResponseObject;
  dropdownSettings = {};
  engineTypes = EngineType;
  engineTypesKey = Object.keys(this.engineTypes);
  documentations = Documentations;
  documentationsKeys = Object.keys(this.documentations);
  submitted = false;
  loading = false;
  showRequest = true;
  isReadOnly: boolean;
  RequestId: string;
  Constants: FibberglassConstants = new FibberglassConstants();
  imagePath: SafeResourceUrl;
  mainSpecificationsJson = [];
  EngineNoteEN: string;
  EngineNoteAR: string;
  currMaxSpeedBoat: number;
  displayedLang: any;
  Languages = Languages;
  numberRegex: string = '^[0-9]*$';
  greaterThanZeroRegex: string = '^[1-9][0-9]*$';
  isErrorMessage: boolean = false;
  userInfo: any;
  baseRequestDTO: BaseRequest;


  constructor(private lookupService: LookupService, private formBuilder: FormBuilder, private route: ActivatedRoute, private fibberglassService: FibberglassRequestService, private sanitizer: DomSanitizer, private global: GlobalServices, private router: Router,private baseRequestService: BaseRequestService, private authSrevice: AuthenticationService) {
    if (history.state.data && history.state.data.requestId)
      this.RequestId = history.state.data.requestId;
    this.engineTypesKey = this.engineTypesKey.slice(this.engineTypesKey.length / 2);
    this.documentationsKeys = this.documentationsKeys.slice(this.documentationsKeys.length / 2);
    this.displayedLang = this.global.getLanguage();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.global.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.global.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.global.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true,
      bindValue: 'Id'
    };
    this.createForm();
  }

  ngOnInit() {
    this.isReadOnly = this.RequestId ? true : false;
    this.RequestId ? this.fibberglassRequestForm.disable() : null;
    if (history.state.data && history.state.data.isCompleted){
      this.isReadOnly = true;
     }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    this.getFibberglassLookUps();
    if (this.RequestId) {
      this.viewFibberglassMode();
      this.getBaseRequest();
    }
  }

  get EngineType() {
    return EngineType;
  }

  get Validate() {
    return this.fibberglassRequestForm.controls;
  }

  get ValidateLaunchBoat() {
    return this.fibberglassRequestForm.controls.LaunchBoat['controls'];
  }

  get ValidateLaunchOption() {
    return this.fibberglassRequestForm.controls.LaunchBoat['controls'].LaunchOptions['controls'];
  }

  get ValidateEngine() {
    return this.fibberglassRequestForm.controls.LaunchBoat['controls'].EngineControl['controls'];
  }

  getBaseRequest() {

    this.baseRequestService.getBaseRequest(this.RequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;

      }
    )
  }

  get Check380On220Volt() {
    let Checked: boolean = false;
    let SelectedLightingLoads = this.fibberglassRequestForm.controls.LaunchBoat['controls'].LaunchOptions['controls'].SelectedLightingAndLoads.value;
    if (SelectedLightingLoads) {
      Checked = SelectedLightingLoads.some(function (current) {
        return current.Id == this.Volt380on220;
      }, this.Constants);
    }
    return Checked;
  }

  getFibberglassLookUps() {
    //Get Fibberglass Services Lookup
    this.lookupService.GetFibberglassServices().subscribe(
      s => {
        this.Services = s.Data;
      }
    );

    //Get BoatTypes Lookup
    this.lookupService.GetBoatTypes().subscribe(
      b => {
        this.BoatTypes = b.Data;
      }
    );

    //Get Communications And Navigations Lookup
    this.lookupService.GetCommunicationsNavigations().subscribe(
      c => {
        this.CommunicationsAndNavigationsOptions = c.Data;
      }
    );

    //Get Lighting Loads Lookup
    this.lookupService.GetLightingLoads().subscribe(
      l => {
        this.LightingAndLoadsOptions = l.Data;
      }
    );

    //Get Volts DC 380On220 Lookup
    this.lookupService.GetVoltsDC380On220().subscribe(
      v => {
        this.VoltDCs380On220Options = v.Data;
      }
    );

    //Get Yacht Safeties Lookup
    this.lookupService.GetYachtSafeties().subscribe(
      y => {
        this.YachtSafetiesOptions = y.Data;
      }
    );

    //Get Extra Documentations Lookup
    this.lookupService.GetFibberglassExtraDocumentations().subscribe(
      b => {
        this.ExtraDocumentationsOptions = b.Data;
      }
    );

    //Get Clients Lookup
    this.lookupService.GetFibberglassClients().subscribe(
      b => {
        this.Clients = b.Data;
      }
    );
  }

  createForm() {
    this.fibberglassRequestForm = this.formBuilder.group({
      CurrUserId: [this.authSrevice.currentUserValue.UserId],
      UserRequiredModifications: [''],
      ServiceId: ['undefined', Validators.required],
      BoatTypeId: ['undefined'],
      NoOfBoats: [''],
      WithEngine: [''],
      Engine: [''],
      Notes: [''],
      LaunchBoat: this.formBuilder.group({
        NoOfBoatsControl: ['', [Validators.required, Validators.pattern(this.greaterThanZeroRegex)]],
        LaunchOptions: this.formBuilder.group({
          SelectedCommunicationsAndNavigations: [''],
          SelectedLightingAndLoads: [''],
          SelectedVoltDCs380On220: [''],
          SelectedYachtSafeties: [''],
          SelectedExtraDocumentations: ['']
        }),
        WithEngineControl: [''],
        EngineControl: this.formBuilder.group({
          TypeOfEngine: [''],
          SpeedOfBoat: ['']
        }),
        NotesControl: ['', Validators.maxLength(500)]
      }),
      ClientId: ['undefined', Validators.required],
      communicationsNavigationsIds: [''],
      lightingLoadsIds: [''],
      voltsDC380On220Ids: [''],
      yachtSafetiesIds: [''],
      extraDocumentationsIds: [''],
      TermsAndConditionsControl: ['', Validators.requiredTrue]
    });
  }

  onServiceChange(optionValue) {
    if (optionValue != "undefined") {
      this.fibberglassService.getServiceImage(optionValue).subscribe(
        s => {

          this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data);
        }
      );
    }
    else {
      this.imagePath = "";
    }
    this.fibberglassRequestForm.controls.BoatTypeId.setValue('undefined');
    this.fibberglassRequestForm.controls.LaunchBoat.reset();
    if (this.Validate.ServiceId.value == this.Constants.MakeLaunch) {
      this.Validate.BoatTypeId.setValidators([Validators.required]);

    }
    else {
      this.Validate.BoatTypeId.clearValidators();
      this.ValidateLaunchBoat.NoOfBoatsControl.clearValidators();

      this.ValidateLaunchBoat.WithEngineControl.clearValidators();
      this.fibberglassRequestForm.controls.LaunchBoat.reset();
      this.ValidateEngine.TypeOfEngine.clearValidators();
      this.ValidateEngine.SpeedOfBoat.clearValidators();
      this.ValidateLaunchBoat.EngineControl.reset();

    }
  }

  onBoatTypeChange(optionValue) {
    this.fibberglassRequestForm.controls.LaunchBoat.reset();
    if (optionValue != "undefined") {
      this.mainSpecificationsJson = [];
      this.EngineNoteEN = "";
      this.EngineNoteAR = "";
      this.fibberglassService.getBoatTypeSettings(optionValue).subscribe(
        s => {

         this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data.BoatImage);




          // this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data.BoatImage);
          this.currMaxSpeedBoat = s.Data.MaxSpeedBoat != null ? s.Data.MaxSpeedBoat : 0;
          let json = JSON.parse(this.global.getLanguage() == Languages.English ? s.Data.SpecificationEN : s.Data.SpecificationAR);
          for (var type in json) {
            let item = { "key": "", "value": "" };
            item.key = type;
            item.value = json[type];
            this.mainSpecificationsJson.push(item);
          }
          if (s.Data.LightingLoad) {
            if (optionValue == this.Constants.FullLaunch[0] || optionValue == this.Constants.FullLaunch[1]) {
              let SelectedDefaultVolt: LookUp[] = [];
              SelectedDefaultVolt.push(s.Data.LightingLoad);

              this.fibberglassRequestForm.controls.LaunchBoat['controls'].LaunchOptions.controls.SelectedLightingAndLoads.reset();
              this.fibberglassRequestForm.controls.LaunchBoat['controls'].LaunchOptions.controls.SelectedLightingAndLoads.setValue(SelectedDefaultVolt);

              let element: HTMLElement = document.getElementsByTagName('Html')[0] as HTMLElement;
              element.click();
            }


            if (optionValue == this.Constants.FastPassLaunch) {
              this.fibberglassRequestForm.get('LaunchBoat').get('LaunchOptions').get('SelectedLightingAndLoads').setValidators([Validators.required]);
              this.fibberglassRequestForm.get('LaunchBoat').get('LaunchOptions').get('SelectedLightingAndLoads').updateValueAndValidity();
            } else {
              this.fibberglassRequestForm.get('LaunchBoat').get('LaunchOptions').get('SelectedLightingAndLoads').setValidators(null);
              this.fibberglassRequestForm.get('LaunchBoat').get('LaunchOptions').get('SelectedLightingAndLoads').updateValueAndValidity();

            }
          }
          this.EngineNoteEN = s.Data.SpeedBoatNoteEN;
          this.EngineNoteAR = s.Data.SpeedBoatNoteAR;
        }
      );
    }
    else {
      this.fibberglassService.getServiceImage(this.Validate.ServiceId.value).subscribe(
        s => {
          this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data);
        }
      );
    }

    if (this.Validate.BoatTypeId.value && this.Validate.BoatTypeId.value != this.Constants.FalokaLaunch) {
      this.ValidateLaunchBoat.WithEngineControl.setValidators([Validators.required]);
    }
    else {
      this.ValidateLaunchBoat.WithEngineControl.clearValidators();
      this.fibberglassRequestForm.controls.LaunchBoat.reset();
      this.ValidateEngine.TypeOfEngine.clearValidators();
      this.ValidateEngine.SpeedOfBoat.clearValidators();
      this.ValidateLaunchBoat.EngineControl.reset();
    }
  }

  onEngineChange(optionValue) {
    if (this.ValidateLaunchBoat.WithEngineControl.value == EngineType.WithEngine) {
      this.ValidateEngine.TypeOfEngine.setValidators([Validators.maxLength(50)]);
      this.ValidateEngine.SpeedOfBoat.setValidators([Validators.required, Validators.max(this.currMaxSpeedBoat)]);
    }
    else {
      this.ValidateEngine.TypeOfEngine.clearValidators();
      this.ValidateEngine.SpeedOfBoat.clearValidators();
      this.ValidateLaunchBoat.EngineControl.reset();
    }
  }

  MultiSelectMap() {
    let SelectedCommunicationsAndNavigations = this.fibberglassRequestForm.controls['LaunchBoat'].value.LaunchOptions.SelectedCommunicationsAndNavigations;
    if (SelectedCommunicationsAndNavigations) {
      let SelectedCommunicationsNavigationsIds = SelectedCommunicationsAndNavigations.map(function (currItem) {
        return currItem.Id;
      });
      this.fibberglassRequestForm.controls['communicationsNavigationsIds'].setValue(SelectedCommunicationsNavigationsIds);
    }

    let SelectedLightingAndLoads = this.fibberglassRequestForm.controls['LaunchBoat'].value.LaunchOptions.SelectedLightingAndLoads;
    if (SelectedLightingAndLoads) {
      let SelectedLightingLoadsIds = SelectedLightingAndLoads.map(function (currItem) {
        return currItem.Id;
      });
      this.fibberglassRequestForm.controls['lightingLoadsIds'].setValue(SelectedLightingLoadsIds);
    }

    let SelectedVoltDCs380On220 = this.fibberglassRequestForm.controls['LaunchBoat'].value.LaunchOptions.SelectedVoltDCs380On220;
    if (SelectedVoltDCs380On220) {
      let SelectedVoltsDC380On220Ids = SelectedVoltDCs380On220.map(function (currItem) {
        return currItem.Id;
      });
      this.fibberglassRequestForm.controls['voltsDC380On220Ids'].setValue(SelectedVoltsDC380On220Ids);
    }

    let SelectedYachtSafeties = this.fibberglassRequestForm.controls['LaunchBoat'].value.LaunchOptions.SelectedYachtSafeties;
    if (SelectedYachtSafeties) {
      let SelectedYachtSafetiesIds = SelectedYachtSafeties.map(function (currItem) {
        return currItem.Id;
      });
      this.fibberglassRequestForm.controls['yachtSafetiesIds'].setValue(SelectedYachtSafetiesIds);
    }

    let SelectedExtraDocumentations = this.fibberglassRequestForm.controls['LaunchBoat'].value.LaunchOptions.SelectedExtraDocumentations;
    if (SelectedExtraDocumentations) {
      let SelectedExtraDocumentationsIds = SelectedExtraDocumentations.map(function (currItem) {
        return currItem.Id;
      });
      this.fibberglassRequestForm.controls['extraDocumentationsIds'].setValue(SelectedExtraDocumentationsIds);
    }
  }

  onSubmit() {

    this.submitted = true;
    if (this.fibberglassRequestForm.invalid || this.Validate.ServiceId.value == "undefined" || this.Validate.ClientId.value == "undefined") {
      return;
    }
    //this.fibberglassRequestForm.controls['MobileNumber'].setValue(this.fibberglassRequestForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.fibberglassRequestForm.patchValue({
      ['NoOfBoats']: this.fibberglassRequestForm.controls['LaunchBoat'].value.NoOfBoatsControl,
      ['WithEngine']: this.fibberglassRequestForm.controls['LaunchBoat'].value.WithEngineControl == 2 ? true : false,
      ['Engine']: this.fibberglassRequestForm.controls['LaunchBoat'].value.EngineControl,
      ['Notes']: this.fibberglassRequestForm.controls['LaunchBoat'].value.NotesControl,
    });
    this.MultiSelectMap();
    this.loading = true;
    this.fibberglassRequestDTO = this.fibberglassRequestForm.value;

    this.fibberglassRequestDTO.BoatTypeId = this.fibberglassRequestForm.controls['BoatTypeId'].value == 'undefined' ? null : this.fibberglassRequestForm.controls['BoatTypeId'].value;
    this.fibberglassRequestDTO.MobileNumber = this.fibberglassRequestForm.controls.MobileNumber.value;
    this.fibberglassService.addFibberglassRequest(this.fibberglassRequestDTO).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          this.fibberglassRequestForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Fail");
        }
      });
  }

  viewFibberglassMode() {
    this.fibberglassService.getFibberglassRequest(this.RequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.fibberglassRequestForm.patchValue({
            UserRequiredModifications: resObj.Data['UserRequiredModifications'] != null ? resObj.Data['UserRequiredModifications'] : "",
            ServiceId: resObj.Data['ServiceId'].toString(),
            BoatTypeId: resObj.Data['BoatTypeId'] != null ? resObj.Data['BoatTypeId'].toString() : "undefined",
            LaunchBoat: {
              NoOfBoatsControl: resObj.Data['NoOfBoats'],
              LaunchOptions: {
                SelectedCommunicationsAndNavigations: resObj.Data['CommunicationsAndNavigations'],
                SelectedLightingAndLoads: resObj.Data['LightingAndLoads'],
                SelectedVoltDCs380On220: resObj.Data['VoltDCs380On220'],
                SelectedYachtSafeties: resObj.Data['YachtSafeties'],
                SelectedExtraDocumentations: resObj.Data['ExtraDocumentations'],
              },
              WithEngineControl: resObj.Data['WithEngine'] == true ? EngineType.WithEngine : EngineType.WithoutEngine,
              EngineControl: resObj.Data['Engine'],
              NotesControl: resObj.Data['Notes'],
            },
            ClientId: resObj.Data['ClientId'].toString(),
            MobileNumber: resObj.Data['MobileNumber'],
            Fax: resObj.Data['Fax'],
            TermsAndConditionsControl: true,
          });
          this.userInfo = {
            MobileNumber: resObj.Data['MobileNumber'],
            Fax: resObj.Data['Fax']
          };
          if (resObj.Data['ServiceId'] != this.Constants.MakeLaunch) {
            this.fibberglassService.getServiceImage(resObj.Data['ServiceId']).subscribe(
              s => {
                this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data);
              }
            );
          }
          else {
            this.fibberglassService.getBoatTypeSettings(resObj.Data['BoatTypeId']).subscribe(
              s => {
                this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + s.Data.BoatImage);
                let json = JSON.parse(s.Data.SpecificationEN);
                for (var type in json) {
                  let item = { "key": "", "value": "" };
                  item.key = type;
                  item.value = json[type];
                  this.mainSpecificationsJson.push(item);
                }
              }
            );
          }

          // console.log("Success");
        }
        else {
          // console.log("Fail");
        }
      });
  }

  goToTermsAndConditions(): void {
    if (this.global.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }

  // SetMe()
  // {
  //   var ImageSetting = {"serviceId": Number(this.fibberglassRequestForm.value.BoatTypeId), "Image": this.Constants.base64Image};
  //   this.http.post('Fibberglass/SetServiceImage', ImageSetting).subscribe(
  //     res => {
  //       let x = res.Data;
  //       console.log(x);
  //     }
  //   );
  // }
}
